import axios from 'axios';


export const getWorkspaceDataOnline =  function() {
    return new Promise(function(resolve, reject) {
        var lucenePost = {
            "communities": window._lclx.allCommunities,
            "design":"_design/clouseau/_search",
            "index":"userRole",
            "search": {
              "userId": window._lclx.SUBSCRIPTIONS.userId,
              "skip":0,
              "limit":100
            },
            "type": "kwantuMobileAccess"
        };
        
        var URL = window.DOMAIN.replace('/exist/rest', '') + "/apicall/userRoleClouseau";
        var options = {
            url: URL,
            method: "POST",
            data: JSON.stringify(lucenePost),
            contentType: "text/plain",
            dataType: "json"
        };
    
        window.apicall(options)
        .then(function (data) {
            data.lastRefreshed = window.moment().format("DD MMM, hh:mm A");

             window.dao.upsertLocalDoc({
                "_id": "_local/workspace",
                "data": data
            }).then(function(s){
                
                if(data.items.length > 0){
                    var saveNeeded = false;
                    window.dao.get("userpreferences_" + window._lclx.SUBSCRIPTIONS.userId)
                    .then(function (up) {
                        for(var c = 0; c < data.items.length; c++){
                            var cid = data.items[c].id;
    
                            if(up.subscriptions == undefined){
                                up.subscriptions = {}; 
                            }
                            if(up.subscriptions["community_" + cid] == undefined){
                                up.subscriptions["community_" + cid] = [];
                            }
                            for(var i = 0; i < data.items[c].items.length; i++){
                                var uuid = data.items[c].items[i].uuid;
                                if(up.subscriptions["community_" + cid].indexOf(uuid) == -1){
                                    up.subscriptions["community_" + cid].push(uuid);
                                    if(window._lclx.COMMUNITY_CONFIG != undefined){
                                        window._lclx.COMMUNITY_CONFIG.communityCS.push(uuid);
                                    }
                                    saveNeeded = true;
                                }
                            }
                        }
                        
                        if(saveNeeded){
                            window.dao.save(up)
                            .then(function() {
                                resolve(data);
                            })
                            .catch(function() {
                                resolve(data);
                            });
                        } else {
                            resolve(data);
                        }
                    })
                    .catch(function () {
                        var up = {
                            _id: "userpreferences_" + window._lclx.SUBSCRIPTIONS.userId,
                            channels: ["user_" + window._lclx.SUBSCRIPTIONS.userId],
                            type: "userpreferences",
                            subscriptions: {}
                        };
                        
                        for(var c = 0; c < data.items.length; c++){
                            var cid = data.items[c].id;
                            if(up.subscriptions["community_" + cid] == undefined){
                                up.subscriptions["community_" + cid] = [];
                            }
                            for(var i = 0; i < data.items[c].items.length; i++){
                                var uuid = data.items[c].items[i].uuid;
                                if(up.subscriptions["community_" + cid].indexOf(uuid) == -1){
                                    up.subscriptions["community_" + cid].push(uuid);
                                    if(window._lclx.COMMUNITY_CONFIG != undefined){
                                        window._lclx.COMMUNITY_CONFIG?.communityCS?.push(uuid);
                                    }
                                    saveNeeded = true;
                                }
                            }
                        }
                        
                        if(saveNeeded){
                            window.dao.save(up)
                            .then(function() {
                                resolve(data);
                            })
                            .catch(function() {
                                resolve(data);
                            });
                        } else {
                            resolve(data);
                        }
                    });
                } else {
                    resolve(data);
                }

            }).catch(function(e){
                resolve(data);
            })


        })
        .catch(function (xhr) {
            reject(xhr);
        });
    });
};



export const getWorkspaceData = function() {
    
    return new Promise(function(resolve, reject) {
        if(window.app.networkAvailable == true){
          window.dao.get("_local/workspace")
            .then(function(doc) {
                if(doc?.data?.items?.length ==0){
                    getWorkspaceDataOnline()
                    .then(function(data) {
                        resolve(data);
                    })
                    .catch(function(err) {
                        reject(err)
                    });
                } else {
                    resolve(doc.data);
                }
                
            })
            .catch(function(err) {
                console.log(err);
                getWorkspaceDataOnline()
                .then(function(data) {
                    resolve(data);
                })
                .catch(function(err) {
                    reject(err)
                });
            });
        }
        else{
          window.dao.get("_local/workspace")
            .then(function(doc) {
                resolve(doc.data)
            })
            .catch(function(err) {
                reject(err);
            });
        }

    });

};

// Cache-first workspace load (offline capable). The server is only asked when
// forceOnline is set (login, refresh button) or nothing is cached yet; if it
// can't be reached the cached copy is returned instead. Resolves
// { data, fromServer }. Rejects with err.offline = true when there is neither
// a cache nor a network.
export const getWorkspaceDataCacheFirst = async function(forceOnline) {
    let cached = null;
    try {
        cached = (await window.dao.get("_local/workspace")).data;
    } catch (e) {
        // not cached yet
    }
    const hasCache = cached?.items?.length > 0;

    if (window.app.networkAvailable === true && (forceOnline || !hasCache)) {
        try {
            return { data: await getWorkspaceDataOnline(), fromServer: true };
        } catch (err) {
            if (cached) {
                console.warn("Workspace refresh failed, using cached copy.", err);
                return { data: cached, fromServer: false };
            }
            throw err;
        }
    }
    if (cached) {
        return { data: cached, fromServer: false };
    }
    const err = new Error("Workspace not available offline");
    err.offline = true;
    throw err;
};


export const prepareLuceneRequest = function(communityId, applicationId, profileId, subprofileId, type, setId, txtInput, filter,preFilter, sort, cacheUUID){
    if(preFilter == null || preFilter == undefined){
        preFilter = [];
    }

    // FIX: filter (serverFilter) can be an object like { defaultField, filters[] }
    // or a string like "-harvestReadyForComplete:ReadyYes"
    // or an empty string/array when there is no server filter.
    const safePreFilter = Array.isArray(preFilter) ? preFilter : [];
    const safeFilter = Array.isArray(filter) ? filter : [];

    const newFilters = [
        ...safeFilter,
        ...safePreFilter
    ]
    var URL = "";
    if(filter.length > 0 || preFilter != null || preFilter !== undefined){
        var lucenePost = {
            "communityId": communityId,
            "applicationId": applicationId,
            "profileId": profileId || "",
            "subprofileId": subprofileId, 
            "design": window.CLOUSEAU_DESIGN_DOC,
            "index": window.SEARCH_WORKER_INDEX,
            "search": {
                "text": txtInput ? txtInput.toString().toLowerCase() : "",
                "filter": newFilters,
                "limit": 50,
                "sort": sort,
                "setId": setId
            },
            "type": type == 'process'?'newinstance':type,
            "draft": false,
            "overallStatus": false
        }
                                    
    
        URL = window.DOMAIN.replace('/exist/rest', '') + "/apicall/luceneQueryClouseau";
        var options = {
            cacheUUID: cacheUUID,
            url: URL,
            method: "POST",
            data: JSON.stringify(lucenePost),
            contentType: "text/plain",
            dataType: "json"
        };
        return options;
    }
    else{
    
        var lucenePost = {
            "communityId": communityId,
            "applicationId": applicationId,
            "profileId": profileId || "",
            "subprofileId": subprofileId, 
            "design": window.CLOUSEAU_DESIGN_DOC,
            "index": window.SEARCH_WORKER_INDEX,
            "search": {
                "text": txtInput ? txtInput.toString().toLowerCase() : "",
                "limit": 50,
                "sort": sort,
                "setId": setId
            },
            "type": type == 'process'?'newinstance':type,
            "draft": false,
            "overallStatus": false
        }
    
        URL = window.DOMAIN.replace('/exist/rest', '') + "/apicall/luceneQueryClouseau";
        var options = {
            cacheUUID: cacheUUID,
            url: URL,
            method: "POST",
            data: JSON.stringify(lucenePost),
            contentType: "text/plain",
            dataType: "json"
        };
        return options;
    }
    
};


export const searchLucene = function(communityId, applicationId, profileId, subprofileId, type, setId, txtInput, filter){
    return new Promise(function (accessServerResolve, accessServerReject) {
        var URL = "";
        if(filter.length > 0){
            var lucenePost = {
                "communityId": communityId,
                "applicationId": applicationId,
                "profileId": profileId || "",
                "subprofileId": subprofileId, 
                "design": window.CLOUSEAU_DESIGN_DOC,
                "index": window.SEARCH_WORKER_INDEX,
                "search": {
                    "text": txtInput,
                    "filter":filter,
                    "limit": 50,
                    "sort": "",
                    "setId": setId
                },
                "type": type == 'process'?'newinstance':type,
                "draft": true,
                "overallStatus": true
            }
                                      
        
            URL = window.DOMAIN.replace('/exist/rest', '') + "/apicall/luceneClouseau";
            var options = {
                url: URL,
                method: "POST",
                data: JSON.stringify(lucenePost),
                contentType: "text/plain",
                dataType: "json"
            };
        
            window.apicall(options)
            .then(function (data) {
                
                accessServerResolve(data);
    
            })
            .catch(function (xhr) {
                console.log(xhr);
                accessServerReject(xhr);
            });
        }
        else{
        
            var lucenePost = {
                "communityId": communityId,
                "applicationId": applicationId,
                "profileId": profileId || "",
                "subprofileId": subprofileId, 
                "design": window.CLOUSEAU_DESIGN_DOC,
                "index": window.LUCENE_GRID_INDEX,
                "search": {
                    "text": txtInput,
                    "limit": 50,
                    "sort": "",
                    "setId": setId
                },
                "type": type == 'process'?'newinstance':type,
                "draft": true,
                "overallStatus": true
            }
        
            URL = window.DOMAIN.replace('/exist/rest', '') + "/apicall/luceneQueryClouseau";
            var options = {
                url: URL,
                method: "POST",
                data: JSON.stringify(lucenePost),
                contentType: "text/plain",
                dataType: "json"
            };
        
            window.apicall(options)
            .then(function (data) {
                
                accessServerResolve(data);

            })
            .catch(function (xhr) {
                console.log(xhr);
                accessServerReject(xhr);
            });
        }
    });
}

export async function get(id) {
    return await window.dao.get(id);
}

export async function getConfig(id) {
    return await window.dao.getConfig(id);
}

export async function getViewData(communityId, config, filters, page, size) {

    return new Promise(function (resolve, reject) {

        const filter = {
            "defaultFilter": config.dataView?.filter?.defaultFilter,
            "filters": filters
        };

        const packet = {
            "communityId": communityId,
            "viewName": config.dataView.viewId,
            "fields": config.dataView.fields,
            "filter": filter,
            "page": page,
            "size": size,
            "sort": config.dataView?.sort
        };

        let URL = "http://localhost:5012/apicall/dataView";

        axios.post(URL, JSON.stringify(packet)).then((response) => {
           console.log('Response Data:', response.data);
           resolve(response.data);
        }).catch((error) => {
           console.error('Axios Error:', error);
           reject(error);
        });
    });
}

export const getParticipantsDataOnlineOnly = function (communityId, applicationId, profileId, subprofileId) {
    return new Promise(function (resolve, reject) {
        const cacheUUID = window.CACHE_PREFIX +
            (window._lclx.hubCode !== undefined ? window._lclx.hubCode + ":" : ":") +
            (communityId ? communityId + ":" : ":") +
            (applicationId ? applicationId + ":" : ":") +
            (profileId ? profileId + ":" : ":") +
            (subprofileId ? subprofileId : "") + ":participants";

        const localKey = `_local/${cacheUUID}`;
        const URL = window.DOMAIN.split("/exist")[0] + "/apicall/localityCharts";

        const apiCallOptions = {
            url: URL,
            method: "POST",
            data: JSON.stringify({
                communityId: communityId,
                applicationId: applicationId,
                subprofileId: subprofileId
            }),
            contentType: "text/plain",
            dataType: "json"
        };

        window.apicall(apiCallOptions)
            .then(function (data) {
                if (data.isError === true || data.error === "bad_request") {
                    return reject(data);
                }

                const toStore = {
                    _id: localKey,
                    ...data
                };

                window.dao.upsertLocalDoc(toStore)
                    .then(function (s) {
                        resolve(data);
                    })
                    .catch(function (e) {
                        console.warn("Local update failed but returning online data anyway.");
                        resolve(data);
                    });
            })
            .catch(function (err) {
                console.error("getParticipantsDataOnlineOnly error:", err);
                reject({ isError: true, message: "Failed to fetch participants from server." });
            });
    });
};


export const getParticipantsData = function (communityId, applicationId, profileId, subprofileId) {
    return new Promise(function (resolve, reject) {
        const cacheUUID = window.CACHE_PREFIX +
            (window._lclx.hubCode !== undefined ? window._lclx.hubCode + ":" : ":") +
            (communityId ? communityId + ":" : ":") +
            (applicationId ? applicationId + ":" : ":") +
            (profileId ? profileId + ":" : ":") +
            (subprofileId ? subprofileId : "") + ":participants";

        const localKey = `_local/${cacheUUID}`;
        const URL = window.DOMAIN.split("/exist")[0] + "/apicall/localityCharts";

        const apiCallOptions = {
            url: URL,
            method: "POST",
            data: JSON.stringify({
                communityId: communityId,
                applicationId: applicationId,
                subprofileId: subprofileId
            }),
            contentType: "text/plain",
            dataType: "json"
        };

        if (window.app.networkAvailable === true) {
            window.dao.get(localKey)
                .then(function (doc) {
                    if (!doc?.data?.participants || doc?.data?.participants.length === 0) {
                        fetchAndCacheParticipants(apiCallOptions, localKey)
                            .then(resolve)
                            .catch(reject);
                    } else {
                        resolve(doc);
                    }
                })
                .catch(function (err) {
                    console.warn("Error reading local participants cache:", err);
                    fetchAndCacheParticipants(apiCallOptions, localKey)
                        .then(resolve)
                        .catch(reject);
                });
        } else {
            window.dao.get(localKey)
                .then(function (doc) {
                    resolve(doc);
                })
                .catch(function (err) {
                    reject(err);
                });
        }
    });
};

function fetchAndCacheParticipants(apiCallOptions, localKey) {
    return new Promise(function (resolve, reject) {
        window.apicall(apiCallOptions)
            .then(function (data) {
                if (data.isError === true || data.error === "bad_request") {
                    return reject(data);
                }

                if (data?.data?.participants !== undefined) {
                    const toStore = {
                        _id: localKey,
                        ...data
                    };
                    window.dao.upsertLocalDoc(toStore)
                        .then(function () {
                            resolve(data);
                        })
                        .catch(function () {
                            resolve(data);
                        });
                } else {
                    resolve([]);
                }
            })
            .catch(function (err) {
                console.error("API call failed:", err);
                reject({ isError: true, message: "Error fetching participants from server." });
            });
    });
}


// export async function getParticipantsData(communityId, applicationId, profileId, subprofileId) {

//     return new Promise(async function (resolve, reject) {
//         try{
//             const cacheUUID = window.CACHE_PREFIX +
//             (window._lclx.hubCode !== undefined ? window._lclx.hubCode + ":" : ":") +
//             (communityId ? communityId + ":" : ":") +
//             (applicationId ? applicationId + ":" : ":") +
//             (profileId ? profileId + ":" : ":") +
//             (subprofileId ? subprofileId : "") + ":participants";
    
//             const URL = window.DOMAIN.split("/exist")[0] + "/apicall/localityCharts";
            
//             var apiCallOptions = {
//                 cacheUUID: cacheUUID,
//                 url: URL,
//                 method: "POST",
//                 data: JSON.stringify({
//                         "communityId": communityId,
//                         "applicationId": applicationId,
//                         "subprofileId": subprofileId
//                 }),
//                 contentType: "text/plain",
//                 dataType: "json"
//             };
    
//             const cacheObject = await window.dao.getCachedObject(
//                 "",
//                 apiCallOptions, 0
//             );
    
//             if(cacheObject.isError == true){
//                 reject(cacheObject);
//             }
            
//             if(cacheObject.data !== undefined && cacheObject.data.participants !== undefined){
//                 resolve({
//                     applicationId:cacheObject.data.applicationId,
//                     participants:cacheObject.data.participants
//                 });   
//             }
//             else{
//                 resolve([]);
//             }
//         } catch (error) {
//             console.log('Error in getParticipantsData:', error);
//             reject({"isError": true, "message": "Error fetching participants data."});
//         }
//     });

// }

// Used by the shared replication script (app/scripts/replication.js
// refreshSubscriptions) to pick up newly assigned profiles before a refresh.
window.kwRefreshWorkspace = getWorkspaceDataOnline;
